export const version = "strings/5.8.0";
